module.exports = __webpack_public_path__ + "assets/img/kv-bbbb3abe.jpg";